import { Button, Modal } from "flowbite-react";
import { HiExclamation } from "react-icons/hi";

/**
 * Confirmation shown when a user resolves a signal that still has open
 * (not completed / not won't-do) actions. If everything is closed the caller
 * resolves directly without rendering this.
 *
 * @param {boolean}  show
 * @param {number}   openCount - Number of still-open actions
 * @param {boolean}  [loading]
 * @param {Function} onConfirm - resolve anyway
 * @param {Function} onCancel
 */
export const ResolveSignalModal = ({
  show,
  openCount,
  loading,
  onConfirm,
  onCancel,
}) => (
  <Modal show={show} popup onClose={onCancel} size="md">
    <Modal.Header />
    <Modal.Body>
      <div className="text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100">
          <HiExclamation className="h-6 w-6 text-amber-500" />
        </div>
        <h3 className="mb-3 text-lg font-semibold text-gray-900">
          Resolve with open actions?
        </h3>
        <p className="mb-5 text-sm text-gray-500">
          This signal still has{" "}
          <span className="font-semibold text-gray-700">
            {openCount} open action{openCount === 1 ? "" : "s"}
          </span>
          . Resolving marks the issue as handled and moves it to Resolved — the
          open actions stay recorded for reference.
        </p>
        <div className="flex justify-center gap-4">
          <Button color="gray" onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
          <Button color="success" onClick={onConfirm} disabled={loading}>
            Resolve anyway
          </Button>
        </div>
      </div>
    </Modal.Body>
  </Modal>
);
